import { useEffect, useState } from "react";
import { Loading } from "../../../../../Helper/Loading";
import { useAuthState } from "../../../../../Helper/Context";
import { useDispatch, useSelector } from "react-redux";


export const OfficialVisitTable = (props) => {
  const { Month, FinancialYear, AssetID } = props
  const userDetails = useAuthState();
  const { UserID, token, } = userDetails.user
  const dispatch = useDispatch()

  const [OpenModal, setOpenModal] = useState(false);
  const [Flag, setFlag] = useState("");
  const [officerData, setOfficerData] = useState(null)
  const [weekID, setWeekID] = useState("-")

  const handlePopupOpen = (data, week, type, desig) => {
    // console.log(desig)
    if (data && type === "VisitTarget" && desig === "Garden  Assistant") {
      setOfficerData(data)
      setWeekID(week)
      setFlag("VisitTarget")
      setOpenModal(true);
    }
    if (data && type === "Achievement") {
      setOfficerData(data)
      setWeekID(week)
      setFlag("Achievement")
      setOpenModal(true);
    }

    // if (data && type === "Pending" && desig === "Garden  Assistant") {
    //   setOfficerData(data)  
    //   setWeekID(week)
    //   setFlag("Pending")
    //   setOpenModal(true);
    // }

  };

  const handleCloseModal = () => {
    setOpenModal(false)
  }

  useEffect(() => {
    const data = {
      M_FinancialYearID: FinancialYear,
      M_MonthID: Month,
      M_ZoneID: "-",
      M_WardID: "-",
      M_AssetTypeID: AssetID,
      M_WorkTypeID: "-",
      M_UsersID: UserID,
      Flag: "Garden",
      token: token,

    }
    // dispatch(DailyWorkChecklistProgressDashboardAPI({ data }))
  }, [AssetID, FinancialYear, Month])

  // const { mainHeading, heading, tableData, isLoading } = useSelector(state => state.DailyWorkChecklistProgressDashboardSliceData)

  const tableData = {
    "code": 200,
    "status": true,
    "message": "Successful",
    "mainHeading": [
      {
        "manihead": "Officer Details",
        "no": 4
      },
      {
        "manihead": "1st Week",
        "no": 3
      },
      {
        "manihead": "2nd Week",
        "no": 3
      },
      {
        "manihead": "3rd Week",
        "no": 3
      },
      {
        "manihead": "4th Week",
        "no": 3
      },
      {
        "manihead": "5th Week",
        "no": 3
      },
      {
        "manihead": "Total",
        "no": 4
      }
    ],
    "heading": [
      {
        "head": "Project Name"
      },
      {
        "head": "Designation"
      },
      {
        "head": "Officer Name"
      },
      {
        "head": "Ward"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },
      {
        "head": "Target"
      },
      {
        "head": "Achieve."
      },
      {
        "head": "Pending"
      },

    ],
    "data": [
      {
        "ProjectName": "WS - Main Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 100,
            "employeeName": "Vasant Padghan",
            "designationName": "E.E",
            "m_UserID": 154,
            "m_WardID": "-",
            "wardName": "Morbe to Digha",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Ashok Gavit",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Morbe to Digha",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Gajanan Khade",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Morbe to Digha",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 100,
            "employeeName": "Shankar Jadhav",
            "designationName": "E.E",
            "m_UserID": 154,
            "m_WardID": "-",
            "wardName": "All",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Avinash Jadhav",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Airoli",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Rakesh Nimesh",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Airoli",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "-",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Belapur",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "-",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Belapur",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "Laxman Patil",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Digha",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Ajit Bhavari",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Digha",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "Ajit Bhavari",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Ghansoli",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Nitin Jadhav",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Ghansoli",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "Ajit Bhawari",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Koparkhairne",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Nagesh Itkapalle",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Koparkhairne",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "-",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Nerul",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },

          {
            "m_EmployeeID": 151,
            "employeeName": "-",
            "designationName": "JE",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Nerul",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },

        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "Prashant Pimple",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Turbhe",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Suresh Sutar",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Turbhe",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
      {
        "ProjectName": "WS - Distribution Line",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 100,
            "employeeName": "Jitendar Naik",
            "designationName": "D.E",
            "m_UserID": 154,
            "m_WardID": "-",
            "wardName": "Vashi",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Rohan Jale",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Vashi",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },

        ]
      },
      {
        "ProjectName": "WTP",
        "noofrow": 2,
        "rowdata": [
          {
            "m_EmployeeID": 151,
            "employeeName": "Vasant Padghan",
            "designationName": "E.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Bhokarpada",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Maruti Ambedkar",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Bhokarpada",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Arjun Birajdar",
            "designationName": "D.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Bhokarpada",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Vijay Korpale",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Bhokarpada",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          },
          {
            "m_EmployeeID": 151,
            "employeeName": "Rajesh Patil",
            "designationName": "J.E",
            "m_UserID": 155,
            "m_WardID": "-",
            "wardName": "Bhokarpada",
            "week1_VisitTarget": "-",
            "week1_Achievement": "-",
            "week1_Pending": "-",
            "week2_VisitTarget": "-",
            "week2_Achievement": "-",
            "week2_Pending": "-",
            "week3_VisitTarget": "-",
            "week3_Achievement": "-",
            "week3_Pending": "-",
            "week4_VisitTarget": "-",
            "week4_Achievement": "-",
            "week4_Pending": "-",
            "week5_VisitTarget": "-",
            "week5_Achievement": "-",
            "week5_Pending": "-",
            "total_VisitTarget": "-",
            "total_Achievement": "-",
            "total_Pending": "-"
          }
        ]
      },
    ]
  }

  return (
    <>
      {/* {isLoading && <Loading />} */}
      <div
        className="row m-0 p-0  bg-white"
        style={{
          border: "1px solid #0d467ee6",
          borderRadius: "8px ",
          width: "100%",
          overflow: "scroll",
        }}
      >
        <div className="col-12 pt-3 pb-0 m-1">
          <table
            id="totalordergenerated"
            cellPadding="0"
            cellSpacing="0"
            border="0"
            className="table table-bordered "
            style={{ textAlign: "center" }}
          >
            <thead className="gardenworktable" id="customers">
              <tr className="text-center ">
                <th colSpan={22} className="text-center fw-bold fs-6 py-2" style={{ background: '#048a8b' }}>Water Supply Daily Official Schedule</th>
              </tr>

              <tr className="text-center tablethhead2">
                {tableData?.mainHeading &&
                  tableData?.mainHeading.map((i) => {
                    return (
                      <th
                        colSpan={i.no}
                        className="text-center fw-bold fs-6"
                        id="tablecolor"
                      >
                        {i.manihead}
                      </th>
                    );
                  })}
              </tr>

              <tr
                className="text-center gardenworkth"
                style={{ width: "100%" }}
              >
                {tableData?.heading &&
                  tableData?.heading.map((j) => {
                    // <></>
                    return (
                      <th
                        className="text-center fw-bold"
                        style={{ whiteSpace: "nowrap" }}
                      >
                        {j.head}
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody>
              {tableData?.data?.map((designation) => {
                return designation.rowdata?.map((officer, officerIndex) => {
                  const rowSpan = designation.rowdata?.length || 1;
                  return (
                    <tr
                      className="text-center"
                      key={`${designation.designationName}-${officerIndex}`}
                    >
                      {officerIndex === 0 ? (
                        <td className="text-center" rowSpan={rowSpan} >
                          {designation.ProjectName}
                        </td>
                      ) : null}
                      <td >{officer.designationName}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{officer.employeeName}</td>
                      <td style={{ whiteSpace: "nowrap" }}>{officer.wardName}</td>

                      {/* Week 1 */}
                      <td role="button" onClick={() => handlePopupOpen(officer, 1, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week1_VisitTarget}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 1, "Achievement")} className="greencolorCount text-center">{officer.week1_Achievement}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 1, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week1_Pending}</td>

                      {/* Week 2 */}
                      <td role="button" onClick={() => handlePopupOpen(officer, 2, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week2_VisitTarget}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 2, "Achievement")} className="greencolorCount text-center">{officer.week2_Achievement}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 2, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week2_Pending}</td>

                      {/* Week 3 */}
                      <td role="button" onClick={() => handlePopupOpen(officer, 3, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week3_VisitTarget}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 3, "Achievement")} className="greencolorCount text-center">{officer.week3_Achievement}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 3, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week3_Pending}</td>

                      {/* Week 4 */}
                      <td role="button" onClick={() => handlePopupOpen(officer, 4, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week4_VisitTarget}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 4, "Achievement")} className="greencolorCount text-center">{officer.week4_Achievement}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 4, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week4_Pending}</td>

                      {/* Week 5 */}
                      <td role="button" onClick={() => handlePopupOpen(officer, 5, "VisitTarget", designation.designationName)} className="bluecolorCount text-center">{officer.week5_VisitTarget}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 5, "Achievement")} className="greencolorCount text-center">{officer.week5_Achievement}</td>
                      <td role="button" onClick={() => handlePopupOpen(officer, 5, "Pending", designation.designationName)} className="orangecolorCount text-center">{officer.week5_Pending}</td>

                      {/* Totals */}
                      <td className="bluecolorCount text-center">{officer.total_VisitTarget}</td>
                      <td className="greencolorCount text-center">{officer.total_Achievement}</td>
                      <td className="orangecolorCount text-center">{officer.total_Pending}</td>



                      {/* KPI Assign (optional) */}

                    </tr>
                  );
                });
              })}
            </tbody>

          </table>
        </div>
      </div>

      {/* {OpenModal &&
        <VisitTargetWeekModal
          handleOpenModal={handlePopupOpen}
          ApiFlag={Flag}
          handleCloseModal={handleCloseModal}
          weekID={weekID}
          officerData={officerData}
          FinancialYear={FinancialYear}
          Month={Month}
        />
      } */}
    </>
  )
}

